// @flow
import styles from './SignedOutDashboard.less';

import React, { PureComponent } from 'react';

import {
  ProfileIcon,
  Hidden,
  PageBlock,
  ScreenReaderOnly,
  Text
} from 'seek-style-guide/react';
import SignInRegisterLink, {
  ANALYTICS_LOGIN_PREFIXES,
  LOGIN_MODES
} from 'src/components/SignInRegisterLink/SignInRegisterLink';

const analyticsPrefix = 'body'; // Should be 'body' specifically as requested by analytics team

const registerLinkProps = {
  analytics: `${analyticsPrefix}:${ANALYTICS_LOGIN_PREFIXES.REGISTER}`,
  mode: LOGIN_MODES.REGISTER,
  'data-automation': 'dashboardRegister',
  children: 'Register'
};

const signInLinkProps = {
  analytics: `${analyticsPrefix}:${ANALYTICS_LOGIN_PREFIXES.SIGN_IN}`,
  mode: LOGIN_MODES.SIGN_IN,
  'data-automation': 'dashboardSignIn',
  children: 'Sign in'
};

export default class SignedOutDashboard extends PureComponent<*> {
  render() {
    return (
      <PageBlock className={styles.root} data-automation="signedOutDashboard">
        <nav
          aria-labelledby="SignedOutDashboardHeading"
          className={styles.content}
        >
          <ScreenReaderOnly>
            <h1 id="SignedOutDashboardHeading">Sign in or register</h1>
          </ScreenReaderOnly>

          <Hidden mobile>
            <ProfileIcon svgClassName={styles.iconSvg} />
          </Hidden>

          <Text
            raw
            subheading
            regular
            baseline={false}
            className={styles.linksWrapper}
          >
            <span className={styles.links}>
              <SignInRegisterLink {...signInLinkProps} />
              <Hidden mobile>&nbsp;or&nbsp;</Hidden>
              <SignInRegisterLink {...registerLinkProps} />
            </span>
            <Hidden mobile>
              &nbsp;to see your saved searches and saved jobs on all your
              devices
            </Hidden>
          </Text>
        </nav>
        <Hidden desktop>
          <Text small baseline={false}>
            Sign in to save jobs and searches, and see jobs recommended for you
          </Text>
        </Hidden>
      </PageBlock>
    );
  }
}
